export default __webpack_public_path__ + "static/scam-alert-desktop-18cfd68469e4d053242566052f6f29e0.webp";